module.exports = function(fn) {
  return function(a, b, c) {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/3.js
// module id = ./node_modules/arity-n/3.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons